/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'
import Ratio from 'components/Ratio'

import './style'
import './media'

/*Ui*/

/*Images*/

/* CORES */
import AppCore from 'cores/AppCore'

const DoctorCard = props => (
    <div className="doctor-card" id={props.id}>
        <div className="doctor-card__wrapp" >
            <div className="doctor__photo">
                <Ratio value={0.89}>
                    {props.photo}
                </Ratio>
            </div>
            <div className="doctor-card__content">
                <div className="doctor-card__name">
                    {props.name}
                </div>
                {props.children}
                <div className={c("doctor-description", props.className)}>
                    {props.description}
                </div>
            </div>
            <div className={c("doctor-description_mobile doctor-description", props.className)}>
                {props.description}
            </div>
        </div>
    </div>
)

// const Rating = props => (
//     <div className={c("rating", props.className)}>
//         <div className="rating__icon">
//             {Math.round(props.value * 10) / 10}
//         </div>
//         <div className="rating__label">
//             Рейтинг на Skin.Expert
//         </div>
//     </div>
// ) 

const Experience = props => (
    <div className={c("experience", props.className)}>
        <div className="experience__value">
            {props.value}
        </div>
        <div className="experience__label">
            { AppCore.Interfaces.t( "DoctorLanding.Ui.DoctorCard.Index.TextExperience" ) }
        </div>
    </div>
) 


// const DoctorDescription = props => (
//     <div className={c("doctor-description", props.className)}>
//         {props.children}
//     </div>
// ) 

const ActionWrapp = props => (
    <div className={c("action-wrapp", props.className)}>
        {props.children}
    </div>
) 

export { /*Rating,*/ Experience, ActionWrapp} 
export default DoctorCard